import "hammerjs";
import { enableProdMode, provideZoneChangeDetection } from "@angular/core";
import { environment } from "./environments/environment";
import { CoreService } from "./app/shared/core/core.service";
import { BluetoothService } from "./app/shared/core/bluetooth.service";
import { PosthogService } from "./app/shared/core/posthog.service";
import { provideHttpClient, withInterceptors, withJsonpSupport, withXhr } from "@angular/common/http";
import { AuthInterceptorService } from "./app/shared/auth/auth-interceptor.service";
import { ErrorInterceptor } from "./app/shared/auth/error-interceptor.service";
import { RouteReuseStrategy, provideRouter, withPreloading, PreloadAllModules } from "@angular/router";
import { IonicRouteStrategy, provideIonicAngular } from "@ionic/angular";
import { provideLottieOptions } from "ngx-lottie";
import { provideAnimations } from "@angular/platform-browser/animations";
import { bootstrapApplication } from "@angular/platform-browser";
import { AuthShell } from "./app/auth/auth-shell";
import { LOGIN_ROUTES } from "./app/auth/login.routes";
import { isLoginOrigin, isAuthShell, isDashboardOrigin } from "./app/shared/auth/auth-origins";
import { AppComponent } from "./app/app.component";
import { importProvidersFrom } from "@angular/core"; // Added import
import { NgxEchartsModule } from "ngx-echarts";
import { EVENT_MANAGER_PLUGINS } from "@angular/platform-browser";
import { HammerGesturePlugin } from "./app/shared/gestures/hammer-gesture.plugin";

// Import app routes
import { APP_ROUTES } from "./app/app.routes";

// Import ionicons
import { addIcons } from "ionicons";
import {
  home,
  homeOutline,
  mapOutline,
  bandageOutline,
  ellipsisHorizontalOutline,
  bandage,
  map,
  ellipsisHorizontal,
  personOutline,
  personCircleOutline,
  settingsOutline,
  medicalOutline,
  locationOutline,
  swapHorizontalOutline,
  albumsOutline,
  pricetagOutline,
  cloudUploadOutline,
  cloudUpload,
  chevronDownCircleOutline,
  alertCircleOutline,
  informationCircleOutline,
  eyeOutline,
  analyticsOutline,
  peopleOutline,
  addOutline,
  close,
  chatbubbles,
  person,
  helpCircleOutline,
  logOutOutline,
  location,
  chevronDown,
  medkit,
  flask,
  layers,
  trendingDownOutline,
  chevronUp,
  chevronDownOutline,
} from "ionicons/icons";

// For compatibility mode that's used in your authentication service

// Register all icons centrally
addIcons({
  home,
  homeOutline,
  mapOutline,
  bandageOutline,
  ellipsisHorizontalOutline,
  bandage,
  map,
  ellipsisHorizontal,
  personOutline,
  personCircleOutline,
  settingsOutline,
  medicalOutline,
  locationOutline,
  swapHorizontalOutline,
  albumsOutline,
  pricetagOutline,
  cloudUploadOutline,
  cloudUpload,
  alertCircleOutline,
  informationCircleOutline,
  eyeOutline,
  analyticsOutline,
  peopleOutline,
  addOutline,
  close,
  chatbubbles,
  chevronDown,
  chevronUp,
  chevronDownCircleOutline,
  chevronDownOutline,
  person,
  helpCircleOutline,
  logOutOutline,
  location,
  medkit,
  flask,
  layers,
  trendingDownOutline,
});

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(isAuthShell() ? AuthShell : AppComponent, {
  providers: [
    provideZoneChangeDetection(),

    // Angular 22 removed HammerModule; this keeps the (press) and (tap) bindings alive.
    { provide: EVENT_MANAGER_PLUGINS, useClass: HammerGesturePlugin, multi: true },
    CoreService,
    BluetoothService,
    PosthogService,
    // Changed order: Apply withJsonpSupport first, then interceptors
    provideHttpClient(withXhr(), withJsonpSupport(), withInterceptors([AuthInterceptorService, ErrorInterceptor])),
    {
      provide: RouteReuseStrategy,
      useClass: IonicRouteStrategy,
    },
    provideLottieOptions({ player: () => import("lottie-web") }),
    provideIonicAngular({ mode: "ios", innerHTMLTemplatesEnabled: true }),
    provideAnimations(),
    importProvidersFrom(
      NgxEchartsModule.forRoot({
        echarts: () => import("echarts"),
      }),
    ),

    // Firebase is initialised by FirebaseAuthService on the plain Firebase JS SDK,
    // so there are no @angular/fire providers to register here. See that service for
    // why: @angular/fire pins one Angular major and was blocking framework upgrades.

    // Add router provider with preloading strategy
    provideRouter(
      isDashboardOrigin()
        ? [LOGIN_ROUTES.find(route => route.path === "_/dashboard")]
        : isLoginOrigin()
          ? LOGIN_ROUTES
          : APP_ROUTES,
      ...(isAuthShell() ? [] : [withPreloading(PreloadAllModules)]),
    ),
  ],
}).catch(err => console.log(err));
